import React from "react";
import styles from "./Slide2.module.scss";
import { messages } from "../../PostProduction.messages";
import { useIntl } from "react-intl";
import config from "appConfig";
import { useBlocks } from "@jelly/lesson";

export const Slide2: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <h3>{formatMessage(messages.G4_P4_S2_Title1)}</h3>
        <img src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/page04/software.svg`} alt="Software icon" />

        <ul>
          <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S2_Item1) }} />
          <li dangerouslySetInnerHTML={{ __html: formatMessage(messages.G4_P4_S2_Item2) }} />
        </ul>
        <h3>{formatMessage(messages.G4_P4_S2_Title2)}</h3>
        <ul className={styles.hardwareList}>
          <li>
            <div className={styles.item}>
              <div className={styles.imageWrapper}>
                <img
                  src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/page04/headtracker.svg`}
                  alt="Headtracker icon"
                />
              </div>
              {formatMessage(messages.G4_P4_S2_Item3)}
            </div>
          </li>
          <li>
            <div className={styles.item}>
              <div className={styles.imageWrapper}>
                <img src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/page04/vrglasses.svg`} alt="VR Glasses icon" />
              </div>
              {formatMessage(messages.G4_P4_S2_Item4)}
            </div>
          </li>
          <li>
            <div className={styles.item}>
              <div className={styles.imageWrapper}>
                <img
                  src={`${config.STATIC_ASSETS_URL}/lms/guide/guide04/page04/headphones.svg`}
                  alt="Headphones icon"
                />
              </div>
              {formatMessage(messages.G4_P4_S2_Item5)}
            </div>
          </li>
        </ul>
      </div>
      <div className={styles.infoBox}>
        <block.infoBox text={formatMessage(messages.G4_P4_S2_Note)} compact={true} />
      </div>
    </div>
  );
};
